import { render, staticRenderFns } from "./EocDiagnosisCodesV1.vue?vue&type=template&id=2b8a078f&"
import script from "./EocDiagnosisCodesV1.vue?vue&type=script&lang=js&"
export * from "./EocDiagnosisCodesV1.vue?vue&type=script&lang=js&"
import style0 from "./EocDiagnosisCodesV1.vue?vue&type=style&index=0&id=2b8a078f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports